module.exports = __webpack_public_path__ + "img/20190829151306260.21773b2a.jpg";